export default __webpack_public_path__ + "static/media/main_pc.02679d4c.jpg";